var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9785 4.16675C13.4785 4.16675 4.16602 13.5001 4.16602 25.0001C4.16602 36.5001 13.4785 45.8334 24.9785 45.8334C36.4994 45.8334 45.8327 36.5001 45.8327 25.0001C45.8327 13.5001 36.4994 4.16675 24.9785 4.16675ZM24.9994 41.6668C15.791 41.6668 8.33268 34.2084 8.33268 25.0001C8.33268 15.7917 15.791 8.33342 24.9994 8.33342C34.2077 8.33342 41.666 15.7917 41.666 25.0001C41.666 34.2084 34.2077 41.6668 24.9994 41.6668Z",
    fill: "#1A0154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.041 14.5833H22.916V27.0833L33.8535 33.6458L35.416 31.0833L26.041 25.5208V14.5833Z",
    fill: "#1A0154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d08e58a4.svg";
export { ForwardRef as ReactComponent };